import React, { useState } from 'react';
import './SSNField.css';

import eyeIcon from '../../assets/images/eye-purple.svg';
import eyeOffIcon from '../../assets/images/eye-closed.svg';

const SSNField = ({ label, value }) => {
	const [isRevealed, setIsRevealed] = useState(false);

	const handleToggle = () => {
		setIsRevealed((prev) => !prev);
	};

	return (
		<>
			<h3>{label}</h3>
			<div className="field-content">
				{value ? (
					<>
						<h4 className={`field-value ${!isRevealed ? 'is-masked' : ''}`}>
							{isRevealed ? value.replace(/^(\d{3})(\d{2})(\d{4})$/, '$1-$2-$3') : '***-**-****'}
						</h4>

						<button
							className="toggle-button"
							onClick={handleToggle}
							type="button"
							aria-label={isRevealed ? 'Hide information' : 'Show information'}
						>
							<img src={isRevealed ? eyeOffIcon : eyeIcon} className="status-icon" alt="" />
						</button>
					</>
				) : (
					'-'
				)}
			</div>
		</>
	);
};

export default SSNField;
